/* eslint-disable react/no-unescaped-entities */
import * as Api from '@ViewModels';
import { css } from 'aphrodite';
import { observer } from 'mobx-react';
import * as React from 'react';
import { useEventLogging } from '../../../../models/Logging';
import { getSocialMediaPlatformLogoUrl } from '../../../../models/UiUtils';
import { useErrorMessages, useUserSession } from '../../../../models/hooks/appStateHooks';
import {
	useIsSocialMediaConnectionBusy,
	useSocialMediaAuthUrlMutation,
} from '../../../../queries/Social/useSocialMediaConnectionMutations';
import LoginWithFacebookImageUrl from '../../../../web/assets/loginwithfacebook.png';
import { DashboardCardTag } from '../DashboardCard';
import { styleSheet } from './styles';

export interface ISocialMediaSettingsserviceConnectionStatusProps {
	type: Api.SocialMediaType;
}

export function ConnectAccountsSection() {
	return (
		<>
			<div className={css(styleSheet.socialMediaColumn)}>
				<DashboardCardTag styleDeclaration={styleSheet.recentPostsTag}>Connect Social Media Accounts</DashboardCardTag>
				<div className={css(styleSheet.serviceConnections)}>
					{Api.SupportedSocialMediaTypes.map(x => (
						<SocialMediaSettingsServiceConnectionStatus key={x} type={x} />
					))}
				</div>
			</div>
		</>
	);
}

export function RecentPostsSection({ recentPosts }: { recentPosts: Api.ISocialMediaPost[] }) {
	const post = recentPosts?.[0];

	const displayTargets = post?.designatedTargets?.length > 0 ? post.designatedTargets : post?.targets;

	return (
		<div className={css(styleSheet.socialMediaColumn)}>
			<DashboardCardTag styleDeclaration={styleSheet.recentPostsTag}>Most Recent Post</DashboardCardTag>
			{post ? (
				<article className={css(styleSheet.socialMediaPost)}>
					<h3 className={css(styleSheet.socialMediaPostTitle)}>{post.name}</h3>
					<div className={css(styleSheet.socialMediaPostTargets)}>
						{displayTargets?.map((target, index) => {
							const displayName = target.state?.lastConnectionState?.postTargetDisplayName;
							return (
								<figure key={index} className={css(styleSheet.socialMediaPostTarget)}>
									<img
										src={getSocialMediaPlatformLogoUrl(target.provider)}
										className={css(styleSheet.socialMediaPostLogo)}
									/>
									<figcaption className={css(styleSheet.postSubmitter)}>{displayName}</figcaption>
								</figure>
							);
						})}
					</div>
				</article>
			) : (
				<span className={css(styleSheet.postSubmitter)}>You don't have any post to show.</span>
			)}
		</div>
	);
}

export const SocialMediaSettingsServiceConnectionStatus: React.FC<ISocialMediaSettingsserviceConnectionStatusProps> =
	observer(({ type }) => {
		const errorMessages = useErrorMessages();
		const userSession = useUserSession();
		const { logApiError } = useEventLogging('SocialMediaCardConnectionStatus');
		const isBusy = useIsSocialMediaConnectionBusy();
		const { mutateAsync: getAuthUrl } = useSocialMediaAuthUrlMutation();

		const connections = userSession?.user?.socialMediaConnectedAccounts?.filter(x => x.type === type);

		const onCtaClicked = async () => {
			try {
				window.location.href = await getAuthUrl({ type });
			} catch (err) {
				logApiError('GetAuthUrl-Error', err);

				errorMessages.pushApiError(err);
			}
		};

		const getMediaLogo = () => {
			return getSocialMediaPlatformLogoUrl(type);
		};
		const renderConnectBtn = () => {
			return (
				<button
					className={css(type === Api.SocialMediaType.LinkedIn ? styleSheet.linkedInConnect : styleSheet.loginButton)}
					disabled={isBusy}
					onClick={onCtaClicked}
				>
					{type !== Api.SocialMediaType.LinkedIn ? (
						<figure>
							<img src={LoginWithFacebookImageUrl} width={160} alt='facebook' />
						</figure>
					) : (
						<span>Sign in with {type}</span>
					)}
				</button>
			);
		};
		return (
			<div className={css(styleSheet.serviceConnection)}>
				<div className={css(styleSheet.socialButtonContainer)}>
					<img src={getMediaLogo()} width={20} height={20} alt='logo' />
					{connections == null || connections.length === 0 ? renderConnectBtn() : null}
					<div className={css(styleSheet.stackMultipleAccounts)}>
						{connections != null &&
							connections.length > 0 &&
							connections.map(conn => {
								return conn.state === Api.SocialMediaConnectionState.Connected ? (
									<div className={css(styleSheet.serviceConnectedText)} key={conn.userName}>
										<span>{`@${conn.userName}`}</span>
									</div>
								) : (
									renderConnectBtn()
								);
							})}
					</div>
				</div>
			</div>
		);
	});
